import React, { useCallback, useMemo } from "react";
import { Button, colors, fontFamilies } from "@commonsku/styles";
import DropdownMenu, { MenuTrigger } from "../../../DropdownMenu";
import styled from "styled-components";
import { ActionType, PotentialRepeatReportAction } from "./types";

const StyledDropdownMenu = styled(DropdownMenu)`
  & > .dropdown-menu-trigger {
    color: ${colors.primary1.main};
    border-radius: 5px;
    padding: 4px 4px 0 4px;
  }

  &&& > ul {
    border: 2px solid ${colors.primary1.main};
    border-radius: 5px;
    margin-top: 4px;
    right: 1rem;
    min-width: 200px;

    & > li {
      font-family: ${fontFamilies.regular};
      color: ${colors.neutrals.bodyText};
    }
  }
`;

interface ActionDropdownProps {
  dismissed: boolean;
  onActionClick?: (action: ActionType) => void;
}

export function ActionDropdown({ dismissed }: ActionDropdownProps) {
  const handleActionItemClick = useCallback((action: ActionType) => {
    //TODO: Call the prop onActionClick when implementing CORE-1283, CORE-1284, CORE-1285
    switch (action) {
      case PotentialRepeatReportAction.CREATE_TASK:
        // Handle create task action
        break;
      case PotentialRepeatReportAction.CREATE_PROJECT:
        // Handle create project action
        break;
      case PotentialRepeatReportAction.COPY_PRESENTATION:
        // Handle copy presentation action
        break;
      case PotentialRepeatReportAction.COPY_SALES_ORDER:
        // Handle copy sales order action
        break;
      case PotentialRepeatReportAction.DISMISS:
        // Handle dismiss action
        break;
      case PotentialRepeatReportAction.UNDO_DISMISS:
        // Handle undo dismiss action
        break;
      default:
        break;
    }
  }, []);

  const actionDropdownOptions: {
    value: ActionType;
    onClick: () => void;
  }[] = useMemo(() => {
    const dismissedValue = dismissed
      ? PotentialRepeatReportAction.UNDO_DISMISS
      : PotentialRepeatReportAction.DISMISS;

    return [
      {
        value: PotentialRepeatReportAction.CREATE_TASK,
        onClick: () =>
          handleActionItemClick(PotentialRepeatReportAction.CREATE_TASK),
      },
      {
        value: PotentialRepeatReportAction.CREATE_PROJECT,
        onClick: () =>
          handleActionItemClick(PotentialRepeatReportAction.CREATE_PROJECT),
      },
      {
        value: PotentialRepeatReportAction.COPY_PRESENTATION,
        onClick: () =>
          handleActionItemClick(PotentialRepeatReportAction.COPY_PRESENTATION),
      },
      {
        value: PotentialRepeatReportAction.COPY_SALES_ORDER,
        onClick: () =>
          handleActionItemClick(PotentialRepeatReportAction.COPY_SALES_ORDER),
      },
      {
        value: dismissedValue,
        onClick: () => handleActionItemClick(dismissedValue),
      },
    ];
  }, [dismissed, handleActionItemClick]);

  return (
    <StyledDropdownMenu options={actionDropdownOptions}>
      <MenuTrigger>
        <Button>Action</Button>
      </MenuTrigger>
    </StyledDropdownMenu>
  );
}
